
<template>
  <th>
    <v-dialog v-model="dialog" max-width="500px" content-class="rounded-xl">
      <template v-slot:activator="{ value, on: dialog }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltip }">
            <v-btn
              :disabled="value"
              class="ma-2"
              small
              v-on="{ ...tooltip, ...dialog }"
            >
              <v-icon small>mdi-palette-outline</v-icon>
            </v-btn>
          </template>
          <span>Настройка палитры</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Настройка палитры</span>
          <v-spacer></v-spacer>
          <!-- <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card class="mx-auto">
          <v-card-title>Выберите цвета</v-card-title>

          <v-card-text>
            <v-row justify="center" align="center">
              <v-col
                class="shrink"
                v-for="clr in curColors"
                :key="clr.text"
                style="min-width: 220px"
              >
                <v-text-field
                  v-model="clr.text"
                  readonly
                  hide-details
                  class="ma-0 pa-0"
                  solo
                >
                  <template v-slot:append>
                    <v-menu
                      rounded="xl"
                      :value="shown[clr.name]"
                      :close-on-content-click="false"
                    >
                      <template v-slot:activator="{ on }">
                        <div
                          @click="shown[clr.name] = true"
                          :style="{
                            backgroundColor: clr.hex,
                            height: '30px',
                            width: '30px',
                            cursor: 'pointer',
                            borderRadius: '4px',
                          }"
                          v-on="on"
                        />
                      </template>
                      <v-card>
                        <v-card-text class="pa-0">
                          <v-container>
                            <v-row>
                              <v-color-picker
                                hide-mode-switch
                                v-model="clr.hex"
                              ></v-color-picker>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            fab
                            class="success"
                            right
                            @click="colorChange(clr)"
                            ><v-icon>mdi-check</v-icon></v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card>
    </v-dialog>
  </th>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import api from "../config/api";
import cs from "vuetify/lib/util/colors";
import Vue from "vue";

export default {
  data() {
    return {
      snackbar: false,
      text: "Цвета сохранены",
      dialog: false,
      shown: {
        fat: false,
        brut: false,
        hand: false,
        winner: false,
        winner_coef: false,
        rusk: false,
        w1: false,
        w2: false,
        fav_win: false,
        out_win: false,
        min_less: false,
        min_more: false,
        mean_less: false,
        mean_more: false,
        max_less: false,
        max_more: false,
      },
      colors: {
        fat: {
          group: "Добивания",
          text: "Фаталити",
          menu: false,
          hex: cs.red.lighten2,
          name: "fat",
        },
        brut: {
          group: "Добивания",
          text: "Бруталити",
          menu: false,
          hex: cs.green.lighten2,
          name: "brut",
        },
        hand: {
          group: "Добивания",
          text: "Без добивания",
          menu: false,
          hex: cs.blueGrey.lighten4,
          name: "hand",
        },
        winner: {
          group: "Победы",
          text: "Победитель",
          menu: false,
          hex: cs.green.lighten2,
          name: "winner",
        },
        winner_coef: {
          group: "Победы",
          text: "Кф Победитель",
          menu: false,
          hex: cs.orange.lighten2,
          name: "winner_coef",
        },
        rusk: {
          group: "Победы",
          text: "Сухарь",
          menu: false,
          hex: cs.orange.lighten3,
          name: "rusk",
        },
        w1: {
          group: "Победы",
          text: "П1",
          menu: false,
          hex: cs.yellow.lighten3,
          name: "w1",
        },
        w2: {
          group: "Победы",
          menu: false,
          text: "П2",
          hex: cs.purple.lighten3,
          name: "w2",
        },
        fav_win: {
          group: "Победы",
          menu: false,
          text: "Фаворит победа",
          hex: cs.deepPurple.lighten3,
          name: "fav_win",
        },
        out_win: {
          group: "Победы",
          text: "Аутсайдер победа",
          menu: false,
          hex: cs.deepOrange.lighten2,
          name: "out_win",
        },
        min_less: {
          group: "Время",
          text: "Время меньше МИН",
          menu: false,
          hex: cs.green.lighten2,
          name: "min_less",
        },
        min_more: {
          group: "Время",
          text: "Время больше МИН",
          menu: false,
          hex: cs.red.lighten2,
          name: "min_more",
        },
        mean_less: {
          group: "Время",
          text: "Время меньше СР",
          menu: false,
          hex: cs.green.lighten4,
          name: "mean_less",
        },
        mean_more: {
          group: "Время",
          text: "Время больше СР",
          hex: cs.red.lighten4,
          menu: false,
          name: "mean_more",
        },
        max_less: {
          group: "Время",
          text: "Время меньше МАКС",
          menu: false,
          hex: cs.green.lighten2,
          name: "max_less",
        },
        max_more: {
          group: "Время",
          text: "Время больше МАКС",
          menu: false,
          hex: cs.red.lighten2,
          name: "max_more",
        },
      },
      type: "hex",

      url: "/templates/update_template/",
      hex: "#FF00FF",
      //   cur_color: "",
    };
  },
  methods: {
    // ...mapMutations(["addCol", "deleteCol", "setCols"]),
    ...mapActions(["setColors", "setTemplateChanged", "fetchUserTemplates"]),
    ...mapGetters(["getSettings", "getCurrentTemplate"]),

    swatchStyle(color) {
      //   console.log(JSON.stringify(this.colors));
      //   console.log(JSON.stringify(color));
      //   console.log("TRY: " + JSON.stringify(this.colors[color.name].hex));
      return {
        backgroundColor: this.colors[color.name].hex,
        cursor: "pointer",
        height: "30px",
        width: "30px",
        borderRadius: "4px",
      };
    },

    updateTemplate: function () {
      // console.log("Updating template...");
      var settings = this.getSettings();
      //   console.log("COLORS: " + JSON.stringify(settings));
      var name = this.getCurrentTemplate();
      this.loading = true;
      api
        .post(this.url, { settings, name })
        .then((response) => {
          console.log("response:" + JSON.stringify(response.data));
          response;
          this.popupText = "Шаблон успешно обновлён";
          this.popup = true;
        })
        .catch((error) => {
          console.log(error.data);
        });
      this.loading = false;
      this.setTemplateChanged({ value: false });
      this.fetchUserTemplates();
    },
    colorChange(color) {
      Vue.set(this.colors[color.name], "hex", color.hex);
      this.setColors({ value: this.colors });
      this.updateTemplate();
      this.shown[color.name] = false;
      this.$snackbar.showMessage({
        content: "Цвет сохранён",
        color: "green lighten-1",
      });
    },
    sortByKey: function (obj) {
      return Object.keys(obj)
        .sort()
        .reduce(function (result, key) {
          result[key] = obj[key];
          return result;
        }, {});
    },
  },
  computed: {
    curColors: {
      get() {
        return this.sortByKey(this.getSettings().colors);
      },
      set(value) {
        this.setColors({ value: value });
      },
    },
  },
  // created() {
  //   // this.colors = this.getSettings().colors;
  //   // this.curColors = this.getSettings().colors;
  //   // console.log("Current colors:" + this.curColors);
  // },
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
</style>
